module.exports = __webpack_public_path__ + "img/SEGURIFY_comparador_3.d9066504.png";